import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Auth.css';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Please enter your email and password.');
      return;
    }
    setSubmitting(true);
    try {
      await login({ email: email.trim(), password, remember_me: remember });
      // Redirect either to a saved redirect target or homepage Chapters Within section
      const redirectTo = location.state?.from || '/my-sanctuary';
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || 'Could not log you in. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page" data-testid="login-page">
      <Link to="/" className="auth-back">&larr; Back to iCraftz</Link>
      <div className="auth-card">
        <img src="/seal/icraftz-wax-seal-small.png" alt="" className="auth-card-seal" aria-hidden="true" />
        <h1 className="auth-title">Welcome <span className="auth-title-accent">Back</span></h1>
        <p className="auth-sub">Step back into your sanctuary.</p>
        <div className="auth-divider"><span className="auth-divider-line" /><span className="auth-divider-mark">❦</span><span className="auth-divider-line" /></div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div>
            <p className="auth-field-label">Email</p>
            <input
              type="email"
              className="auth-input"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              autoComplete="email"
              required
            />
          </div>
          <div>
            <p className="auth-field-label">Password</p>
            <input
              type="password"
              className="auth-input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              autoComplete="current-password"
              required
            />
          </div>

          <div className="auth-remember">
            <label>
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
                data-testid="login-remember"
              />
              Remember me
            </label>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>

          <button type="submit" className="auth-submit" disabled={submitting} data-testid="login-submit">
            {submitting ? 'Signing in…' : 'Sign In'}
          </button>

          {error && <p className="auth-message auth-message-error" data-testid="login-error">{error}</p>}
        </form>

        <p className="auth-footer">
          New to iCraftz? <Link to="/signup">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
